import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteNews, getNewss, resetState } from "../features/news/newsSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "name",
  },
  {
    title: "Content",
    dataIndex: "content",
  },
  {
    title: "Category",
    dataIndex: "category",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Newslist = () => {
  const [open, setOpen] = useState(false);
  const [NewsId, setNewsId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setNewsId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getNewss());
  }, []);
  const getNewsState = useSelector((state) => state.news.Newss);
  const data1 = [];
  for (let i = 0; i < getNewsState.length; i++) {
    data1.push({
      key: i + 1,
      name: getNewsState[i].title,
      content: getNewsState[i].content,
      category: getNewsState[i].categoryName,

      action: (
        <>
          <Link
            to={`/admin/Add-News/${getNewsState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getNewsState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const handleDeleteNews = (e) => {
    dispatch(deleteNews(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getNewss());
    }, 100);
  };;  
  return (
    <div>
      <h3 className="mb-4 title">News List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          handleDeleteNews(NewsId);
        }}
        title="Are you sure you want to delete this News?"
      />
    </div>
  );
};

export default Newslist;
